<template>
  <div id="workspace">
    <div  class="row_flex">
      <div class="bisque bet_cell" @click="this.random_bet()">Random bet</div>
    </div>
  </div>
</template>

<script>
import {inject, provide} from "vue";
import GameService from '../../services/game.service';
import cashier from "@/services/cashier.service";

export default {
  name: "Lotto100v3",
  data () {
    return {
      bets_data: [],
      selected: [],
      cur_split_selected: [],
      pickCount: 0,
      pickMode: 'pick1',
      bet_aliases: [],
      multipliers:
      {
        'pick_even': 2,
        'pick_odd': 2,
        'pick_draw': 4,
        'pick1': 7,
        'pick2': 80,
        'quiniela': 80,
        'pick3': 900,
        'pick4': 2000,
        'pale': 2000,
        'lottery': 20000,
        'tripleta': 20000,
        'pick-1st': 80,
        'pick-2nd': 15,
        'pick-3rd': 10,
      },
      pick_counts:
      {
        'pick1': 1,
        'pick2': 2,
        'quiniela': 2,
        'pick3': 3,
        'pick4': 4,
        'pale': 4,
        'lottery': 6,
        'tripleta': 6,
        'pick-1st': 2,
        'pick-2nd': 2,
        'pick-3rd': 2
      }
    }
  },
  setup()
  {
    const game_kind = inject('gameKind')
    const game_alias = inject('gameAlias')
    const extra_bet = inject('gameExtra')
    const gameId = inject('gameId');
    return {
      game_kind,
      game_alias,
      extra_bet,
      gameId
    }
  },
  props: ['event', 'public_event', 'bet_value'],
  methods: {


    random_bet()
    {
      let bet_name;
      let bet_first;
      let bet_second;
      let bet_third;
      let bet;
      let for_type = this.random_between(1,3)
      switch (for_type) {
      case 1:
        bet_name = 'l100v3-quiniela';
        bet_first = this.random_between(0,99);
        bet = bet_name+'_'+bet_first;
        break;
      case 2:
        bet_name = 'l100v3-pale';
        bet_first = this.random_between(0,99);
        bet_second = this.random_between(0,99);
        bet = bet_name+'_'+bet_first+'_'+bet_second;
        break;
      case 3:
        bet_name = 'l100v3-tripleta';
        bet_first = this.random_between(0,99);
        bet_second = this.random_between(0,99);
        bet_third = this.random_between(0,99);
        bet = bet_name+'_'+bet_first+'_'+bet_second+'_'+bet_third;
        break;
      }

      this.getBet(bet);

    },
    random_between(min, max)
    {
      min = Math.ceil(min); // Ensure min is an integer
      max = Math.floor(max); // Ensure max is an integer
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    getBetApply(bet)
    {
      this.cur_split_selected = [];

      let found = '';

      for (let sel of this.selected)
      {
        if (sel.bet === bet)
        {
          found = sel;
        }
      }

      if (found !== '')
      {
        this.selected.splice(this.selected.indexOf(found), 1);
      }
      else
      {
        this.getBet(bet);
        //this.addBet();
      }
    },
    getBet(bet)
    {
      if(this.event === '')
      {
        return;
      }

      let iter = 0;

      if(this.pickCount > 0)
      {
        this.cur_split_selected = [];
        iter = this.pickCount-1;
      }

      let even = this.event;

      let found = '';

      for (let sel of this.cur_split_selected)
      {
        if (sel.bet === bet)
        {
          found = sel;
        }
      }

      if (found !== '')
      {
        this.cur_split_selected.splice(this.cur_split_selected.indexOf(found), 1);
      }
      else
      {
        this.cur_split_selected.push({bet: bet, event: even});
      }

      if(this.pick_counts[this.pickMode] === this.cur_split_selected.length)
      {
        this.addBet();
      }
    },
    addBet()
    {
      if(this.cur_split_selected.length === 0)
      {
        return;
      }

      let bet = '';
      let bet_name = '';

      for(let sel of this.cur_split_selected)
      {
        if(bet_name !== '')
        {
          bet_name = bet_name + ';';
        }
        bet_name = bet_name + sel.bet;
        bet = sel.bet;
      }

      let multiplier;

      multiplier = 1;

      this.selected.push({
        bet: bet,
        event: this.event,
        public_event: this.public_event,
        bet_value: this.bet_value,
        multiplier: multiplier,
        bet_name: bet_name,
        ntt: 'n'
      });

      this.$emit('getBet', this.selected);

      this.cur_split_selected = [];
    },
    applyBet(bet)
    {
      let multiplier;

      multiplier = this.multipliers[bet];

      this.selected.push({
        bet: bet,
        event: this.event,
        public_event: this.public_event,
        bet_value: this.bet_value,
        multiplier: multiplier,
        bet_name: bet,
        ntt: 'n'
      });

      this.$emit('getBet', this.selected);
    },
    clearBet()
    {
      this.cur_split_selected = [];
    },
    sortFn(a, b)
    {
      let fa = parseInt(a.bet),
          fb = parseInt(b.bet);

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    },
    checkIsSelected(val)
    {
      let event = this.event;
      let ret = '';

      for(let sel of this.cur_split_selected)
      {
        if(sel.event === event)
        {
          if(sel.bet === val)
          {
            ret += 'selected ';
          }
        }
      }

      return ret;
    },
    setMode(mode, cnt)
    {
      if(mode !== 'normal' && cnt !== 0)
      {
        this.cur_split_selected = [];
      }

      if(mode === this.pickMode && cnt === this.pickCount)
      {
        this.pickMode = 'normal';
        this.pickCount = 0;
      }
      else
      {
        this.pickMode = mode;
        this.pickCount = cnt;
      }
    },
    checkMode(mode)
    {
      let ret = '';
      if(mode === this.pickMode)
      {
        ret = 'selected';
      }
      return ret;
    },
    clear_bet()
    {
      this.selected = [];
    },
    addBetEvent(event)
    {
      if (event.keyCode == 32)
      {
        event.preventDefault();
        this.addBet();
      }
    }
  },
  mounted() {
    window.addEventListener('keyup', this.addBetEvent);
  }
}
</script>

<style scoped>

  #workspace
  {
    height: 100%;
    width: 100%;
    background-color: cornflowerblue;
  }
  .row_flex
  {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #game_bets
  {
    height: 98%;
    width: 100%;
    display: grid;
    grid-template-rows: 11% 11% 11% 11% 11% 11% 11% 11% 11%;
  }
  .verticals_cont
  {
    display: flex;
    flex-direction: column;
  }
  .bet_area
  {
    height: 98%;
    width: 95%;
    display: grid;
    grid-template-columns: 60% 5% 35%;
  }
  .controls_cont
  {
    display: grid;
    grid-template-rows: 50% 50%;
  }
  .bet_cell
  {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #DDDDDD;
    margin: 2px;
    cursor:pointer;
    font-size: 100%;
    font-weight: bold;
    background-color: darkgreen;
    padding: 2px;
  }
  .selected
  {
    box-shadow: inset 0px 0px 0px 5px #53ea93;
    box-sizing: border-box;
    background-color: darkorchid;
    color: white;
  }
  .selected_shatters
  {
    background-color: darkkhaki;
    color: white;
  }
  .bet_line
  {
    width: 100%;
    display: grid;
    grid-template-columns: 10% 10% 10% 10% 10% 10% 10% 10% 10% 10%;
  }
  .bisque
  {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: aliceblue;
    color: black;
    margin: 5px;
    height: 40px;
    width: 100px;
    cursor: pointer;
  }
  .horizontals
  {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 100%
  }
  .verticals
  {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }
  .randoms
  {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .control_buttons
  {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn_ctrl
  {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: aliceblue;
    color: black;
    margin: 5px;
    height: 30px;
    width: 80px;
    cursor: pointer;
  }
  .mb div
  {
    width: 8px;
    height: 8px;
    margin-left: 2px;
    background-color: darkgreen;
  }
  .mb
  {
    padding: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid;
    border-radius: 5px;
    background-color: darkgray;
    cursor: pointer;
  }
  .hb
  {
    height: 30px;
    margin-left: 5px;
  }
  .vb
  {
    margin-top: 5px;
    width: 30px;
    margin-left: 5px;
    display: flex;
    flex-direction: column;
  }
  .vb div
  {
    margin-top: 2px;
  }
  .mbx
  {
    height: 30px;
    width: 30px;
    background-color: white;
    margin-left: 5px;
  }
  .selected_b
  {
    background-color: white;
  }
  .extras>div
  {
    display: flex;
    flex-direction: row;
    width: 50%;
  }
</style>